import React, {useEffect, useState} from "react";

let Group = (props) => {
    return(
        <div style={{padding: "0px 12px 12px", borderBottom:props.hideSeparator ? "" : "1px solid var(--separator)"}}>
            {props.children}
        </div>
    );
}
export default Group;